import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { useHistory } from '@ztechapps/common.hook'

/** Terminal screen shown when the invoice URL is missing, malformed, or has no valid payload. */
export const InvoiceLinkExpired = () => {
  const history = useHistory()

  return (
    <div className="d-flex flex-column align-items-center justify-content-center text-center bg-body gap-3 p-5">
      <h2>This invoice link is expired or invalid</h2>
      <p className="text-secondary">Please request a new invoice from the sender.</p>
      <BusyButton icon="house" text="Go to home" variant="primary" onClick={() => history.push('/')} />
    </div>
  )
}
